/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  addSelfpacedUser,
  deleteSelfPacedUser,
  loadSelfPacedUser,
  updateSelfPacedUser,
  rensedInvitationForSelfPacedUser,
} from "./SelfPacedUserApi";

const initialState: any = {
  loading: false,
  resend_invitaiton_loading: false,
  adderLoading: false,
  deleteLoading: false,
  updateLoading: false,
  editUser: false,
  req_success: false,
  resend_invitation_success: false,
  delete_success: false,
  edit_success: false,
  add_success: false,
  single_user_info: {},
  current_page: 1,
  pagination_data:null,
  all_users: [],
  temp_users: [],
  users: [],
};

const slefPacedUser = createSlice({
  name: "slefPacedUser",
  initialState,
  reducers: {
    editSelfPacedUserinInfo: (state: any, { payload }: PayloadAction<any>) => {
      state.editUser = true;
      state.single_user_info = payload;
    },
    closeSelfPacedUserEditModal: (state: any, { payload }: PayloadAction<any>) => {
      state.editUser = false;
      state.edit_success = false;
    },
    refreshSelfPacedUser: (state: any) => {
      state.users = state.all_users.slice(0, 10);
    },
    selfPacedUserPaginate: (state: any, { payload }: PayloadAction<any>) => {
   
    },
    setSelfPacedCurrentPage: (state, { payload }: PayloadAction<any>) => {
      state.current_page = payload;
    },

    searchSelfPacedUser: (state: any, { payload }: PayloadAction<any>) => {
      if (payload?.length > 1) {
        state.temp_users = state.all_users.filter(
          (user: any) =>
            user.name.toLowerCase().includes(payload.toLowerCase()) ||
            user.email.toLowerCase().includes(payload.toLowerCase())
        );
        state.users = state.temp_users;
      } else {
        state.users = state.all_users;
      }
    },
  },
  extraReducers: (builder) => {
    // LOAD USERS
    builder.addCase(loadSelfPacedUser.pending, (state) => {
      state.loading = true;
      state.req_success = false;
    });
    builder.addCase(
      loadSelfPacedUser.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading = false;
        state.req_success = true;
        state.all_users = payload?.data?.data;
        state.users = state.all_users;
        state.pagination_data = payload?.data?.pagination
      }
    );
    builder.addCase(loadSelfPacedUser.rejected, (state) => {
      state.loading = false;
    });

    // ADD USERS
    builder.addCase(addSelfpacedUser.pending, (state) => {
      state.adderLoading = true;
      state.add_success = false;
    });
    builder.addCase(
      addSelfpacedUser.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.adderLoading = false;
        state.add_success = true;

      }
    );
    builder.addCase(addSelfpacedUser.rejected, (state) => {
      state.adderLoading = false;
      state.add_success = false;
    });

    // RESEND INVITATION
    builder.addCase(rensedInvitationForSelfPacedUser.pending, (state) => {
      state.resend_invitaiton_loading = true;
      state.resend_invitation_success = false;
      state.edit_success = false;
    });
    builder.addCase(
      rensedInvitationForSelfPacedUser.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.resend_invitaiton_loading = false;
        state.resend_invitation_success = true;
        state.edit_success = true;
        state.editUser = false;
      }
    );
    builder.addCase(rensedInvitationForSelfPacedUser.rejected, (state) => {
      state.resend_invitaiton_loading = false;
    });

    // update USERS
    builder.addCase(updateSelfPacedUser.pending, (state) => {
      state.adderLoading = true;
      state.edit_success = false;
    });
    builder.addCase(
      updateSelfPacedUser.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.adderLoading = false;
        state.edit_success = true;

      }
    );
    builder.addCase(updateSelfPacedUser.rejected, (state) => {
      state.adderLoading = false;
      state.edit_success = false;
    });

    // DELETE USERS
    builder.addCase(deleteSelfPacedUser.pending, (state) => {
      state.deleteLoading = true;
      state.delete_success = false;
    });
    builder.addCase(
      deleteSelfPacedUser.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.deleteLoading = false;
        state.delete_success = true;

      }
    );
    builder.addCase(deleteSelfPacedUser.rejected, (state) => {
      state.delete_success = false;
      state.deleteLoading = false;
    });
  },
});

// export const { setRecentSignupEmail, invokeLogout } = slefPacedUser.actions;
export const {
  editSelfPacedUserinInfo,
  selfPacedUserPaginate,
  searchSelfPacedUser,
  closeSelfPacedUserEditModal,
  refreshSelfPacedUser,
  setSelfPacedCurrentPage
} = slefPacedUser.actions;
export default slefPacedUser.reducer;
